import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=20cad688&scoped=true&"
import script from "./SortButton.vue?vue&type=script&lang=ts&"
export * from "./SortButton.vue?vue&type=script&lang=ts&"
import style0 from "./SortButton.vue?vue&type=style&index=0&id=20cad688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cad688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
